var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.topBarHeight()
  var m1 = !(m0 == 0) ? _vm.topBarTop() : null
  var g0 = _vm.searchData.length
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.inputValue = ""
    }
    _vm.e1 = function ($event) {
      _vm.showArea = !_vm.showArea
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }